import type { ProductCard } from '@repo/supergraph/roundup/base/types';
import type { Graph, Thing } from 'schema-dts';
import { LinkedDataJson } from '..';
import { getProductListSchema } from './schema';

export type ProductListDataProps = Graph;

export const ProductListData = ({
  offers,
  id,
  url,
}: {
  offers: ProductCard[];
  id: string;
  url: string;
}) => {
  return <LinkedDataJson<Thing> id={id} schema={getProductListSchema({ offers, url })} />;
};
